/* Free Shipping Progress Bar - Dawn
 *
 * SINGLE SOURCE OF TRUTH FOR THE THRESHOLD: FSB_THRESHOLD_CENTS below.
 * 1200 EGP = 120000 cents. Change that one number to change the bar.
 * (Remember to also update the free shipping rate/discount in Shopify admin.)
 *
 * Mounts itself into the cart drawer footer, the cart page footer, and any
 * [data-fsb-mount] element (the product page snippet). Re-mounts after every
 * cart update because Dawn's Section Rendering API replaces that markup.
 *
 * Bars inside [data-fsb-mount] stay visible even when the cart is empty, so
 * the offer is visible on the product page before anything is added.
 */
(function () {
  'use strict';

  if (window.__freeShippingBarLoaded) return;
  window.__freeShippingBarLoaded = true;

  var FSB_THRESHOLD_CENTS = 120000;

  var MOUNTS = ['.cart-drawer__footer', '.cart__footer', '[data-fsb-mount]'];

  function currencyCode() {
    try {
      return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EGP';
    } catch (e) {
      return 'EGP';
    }
  }

  function money(cents) {
    var code = currencyCode();
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: code,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
    } catch (e) {
      return Math.round(amount) + ' ' + code;
    }
  }

  function innerTemplate() {
    return (
      '<p class="free-shipping-bar__text" aria-live="polite"></p>' +
      '<div class="free-shipping-bar__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" aria-label="Free shipping progress">' +
      '<div class="free-shipping-bar__fill"></div>' +
      '</div>'
    );
  }

  function ensureMounted() {
    MOUNTS.forEach(function (selector) {
      Array.prototype.forEach.call(document.querySelectorAll(selector), function (host) {
        if (host.querySelector('.free-shipping-bar')) return;
        var bar = document.createElement('div');
        bar.className = 'free-shipping-bar';
        bar.innerHTML = innerTemplate();
        host.insertBefore(bar, host.firstChild);
      });
    });

    Array.prototype.forEach.call(document.querySelectorAll('.free-shipping-bar'), function (bar) {
      if (!bar.querySelector('.free-shipping-bar__track')) bar.innerHTML = innerTemplate();
    });
  }

  function render(cart) {
    ensureMounted();

    var isEmpty = !cart || !cart.item_count;
    var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    var remaining = FSB_THRESHOLD_CENTS - total;
    var percent = Math.max(0, Math.min(100, (total / FSB_THRESHOLD_CENTS) * 100));

    Array.prototype.forEach.call(document.querySelectorAll('.free-shipping-bar'), function (bar) {
      // Product page mount stays visible on an empty cart; drawer/cart do not.
      var alwaysShow = !!(bar.closest && bar.closest('[data-fsb-mount]'));
      bar.hidden = isEmpty && !alwaysShow;
      if (bar.hidden) return;

      bar.classList.toggle('is-unlocked', !isEmpty && remaining <= 0);

      var text = bar.querySelector('.free-shipping-bar__text');
      if (text) {
        if (isEmpty) {
          text.textContent = 'Free shipping on orders over ' + money(FSB_THRESHOLD_CENTS);
        } else if (remaining > 0) {
          text.textContent = 'You are ' + money(remaining) + ' away from free shipping';
        } else {
          text.textContent = 'Congrats - you have unlocked free shipping';
        }
      }

      var fill = bar.querySelector('.free-shipping-bar__fill');
      if (fill) fill.style.width = percent + '%';

      var track = bar.querySelector('.free-shipping-bar__track');
      if (track) track.setAttribute('aria-valuenow', Math.round(percent));
    });
  }

  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/cart.js';
  }

  function refresh() {
    fetch(cartUrl())
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  function onCartUpdate(data) {
    var cart = data && (data.cartData || data.cart);
    if (cart && typeof cart.total_price === 'number' && typeof cart.item_count === 'number') {
      render(cart);
    } else {
      refresh();
    }
    setTimeout(refresh, 350);
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(init, 50);
      return;
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    refresh();

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('#cart-icon-bubble, cart-drawer, .cart-drawer')) {
        setTimeout(refresh, 200);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
